import { render, staticRenderFns } from "./PendingReports.vue?vue&type=template&id=0f8c5b6e&scoped=true&"
import script from "./PendingReports.vue?vue&type=script&lang=js&"
export * from "./PendingReports.vue?vue&type=script&lang=js&"
import style0 from "./PendingReports.vue?vue&type=style&index=0&id=0f8c5b6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c5b6e",
  null
  
)

export default component.exports